<template>
    <div style="width: 100%;">
        <el-card style="width: 100%;" class="box-card">
            <div style="margin-left: 200px;">
                <div style="font-size: 16px;margin-bottom: 15px;">基础资料</div>

                <div style="display: flex;justify-content: space-between;">
                    <div style="display: flex;width: 50%;">
                        <div style="display: grid;margin-right: 135px;">
                            <img style="width: 90px;height: 90px;border-radius: 50px;"
                                 :src='businessLicenseFile.url'>
                            <el-button style="height: 30px;margin-top: 10px;" size="mini" type="primary"
                                       @click="update">
                                编辑资料
                            </el-button>
                        </div>
                        <div style="display: grid">
                            <div style="font-size: 14px;height: 20px;">集采商名称：{{collector.name}}</div>
                                <div v-if="collector.organizationType == '1'" style="font-size: 14px;height: 20px;">机构类型：国有企业</div>
                                <div v-if="collector.organizationType == '2'" style="font-size: 14px;height: 20px;">机构类型：集体所有制企业</div>
                                <div v-if="collector.organizationType == '3'" style="font-size: 14px;height: 20px;">机构类型：股份制企业</div>
                                <div v-if="collector.organizationType == '4'" style="font-size: 14px;height: 20px;">机构类型：联营企业</div>
                                <div v-if="collector.organizationType == '5'" style="font-size: 14px;height: 20px;">机构类型：个人独资企业</div>
                            <div style="font-size: 14px;height: 20px;">联系地址：{{collector.address}}</div>
                        </div>
                    </div>

                    <div style="margin-right: 280px;display: flex;">
                        <div>营业执照：</div>
                        <div class="demo-image__preview">
                            <el-image
                                    style="width: 160px;height:100px;"
                                    :src="logoFile.url"
                                    :preview-src-list="[logoFile.url]">
                            </el-image>
                        </div>
<!--                        <img style="width: 160px;height:100px;"-->
<!--                             :src="logoFile.url">-->
                    </div>

                </div>

                <div style="display: flex;justify-content: space-around;margin-top: 40px;align-items: center;">
                    <div style="font-size: 14px;">采集员：{{user.username}}</div>
                    <div style="display: flex;align-items: center;">
                        <div style="font-size: 14px;">联系手机：{{user.phoneNumber}}</div>
                        <div style="margin-left: 30px;">
                            <el-button type="success" size="mini">已关联</el-button>
                        </div>
                    </div>
                    <div style="font-size: 14px;color: #bcbec2;">最近登录时间：{{user.lastLogin}}</div>
                </div>
            </div>
        </el-card>


        <el-card style="margin-top: 20px;">
            <div style="margin-left: 200px;">
                <div style="font-size: 16px;margin-bottom: 15px;">集采品类</div>
                <div>
                    <el-row>
                        <el-button v-for="item in categorys" type="info" size="mini">{{item}}</el-button>
                    </el-row>
                </div>

            </div>

        </el-card>

        <el-card style="margin-top: 20px;height: 200px;">
            <div style="margin-left: 200px;">
                <div style="font-size: 16px;margin-bottom: 15px;">集采数据</div>
                <div style="display: flex;width: 100%;justify-content: space-around;text-align: center;margin-top: 50px;">
                    <div>
                        <div style="font-size: 14px;margin-bottom: 10px;font-weight: 300;">累计集采单</div>
                        <div>{{collectorDetail.collectorOrderTotalNum}}</div>
                    </div>
                    <div>
                        <div style="font-size: 14px;margin-bottom: 10px;font-weight: 300;">累计金额</div>
                        <div>¥{{collectorDetail.collectorOrderTotalMoney}}</div>
                    </div>
                    <div>
                        <div style="font-size: 14px;margin-bottom: 10px;font-weight: 300;">付费集采卡</div>
                        <div>未开通</div>
                    </div>
                    <div>
                        <div style="font-size: 14px;margin-bottom: 10px;font-weight: 300;">集采等级</div>
                        <div>/</div>
                    </div>
                    <div>
                        <div style="font-size: 14px;margin-bottom: 10px;font-weight: 300;">集采卡余额（元）</div>
                        <div>¥0.00</div>
                    </div>
                </div>
                <div style="font-size: 14px; color: rgb(188, 190, 194);margin-top: 40px;">*金额备注：商户收款的微信账户签约有千分之六的手续费扣点</div>
            </div>

        </el-card>

    </div>
</template>

<script>
    import MyTable from "../../components/content/myTable/MyTable";
    import {queryCollectorDetailById, newVue, queryCollectorById} from "../../network/collector";

    export default {
        name: "CollectorList",
        components: {MyTable},

        data() {
            return {
                collectorId:null,
                collectorDetail: {},
                collector:{},
                businessLicenseFile:{},
                logoFile:{},
                user:{},
                categorys:[],
            }
        },
        created() {
            newVue.obj = this;
            this.common.HeaderLocationTwo.href = "/collector/detail";
            this.common.HeaderLocationTwo.name = "采集员详情";
            this.common.HeaderLocationThree.name = "采集商详情";
            if (this.$route.params.id!=null){
                this.collectorId = this.$route.params.id;
                queryCollectorDetailById(this.collectorId).then(res => {
                    console.log(res.data);
                    if (res.code == "200"){
                        this.collectorDetail = res.data;
                        this.collector = res.data.collector;
                        this.businessLicenseFile = res.data.collector.businessLicenseFile;
                        this.logoFile = res.data.collector.logoFile;
                        this.user = res.data.user;
                        for (let i = 0; i < res.data.collector.category.split(",").length; i++) {
                            this.categorys.push(res.data.collector.category.split(",")[i]);
                        }
                    }

                })
            }
        },
        methods: {
            //编辑资料跳转
            update() {
                this.$router.push("../insert/"+this.collectorId);
            },
        }
    }
</script>

<style scoped>

</style>
